import * as Sentry from '@sentry/vue';

/**
 * useErrorHandling composable function that returns handleError
 * function that captures error logs in sentry
 * @returns handleError
 */
export function useErrorHandling() {
  function handleError(message: string, error: any) {
    if (error?.response?.status === 401) return;
    Sentry.captureException(error);

    let errorDetails = 'Details: ' + JSON.stringify(error);
    switch (true) {
      case !!error.response:
        errorDetails = `Status: ${
          error.response.status
        }, Data: ${JSON.stringify(error.response.data)}`;
        break;
      case !!error.request:
        errorDetails = `Request: ${JSON.stringify(error.request)}`;
        break;
      case !!error.message:
        errorDetails = `Message: ${error.message}`;
        break;
    }

    console.error(`✘ Error: ${message} ${errorDetails}`);
  }

  return { handleError };
}
